import { proxy } from 'valtio';

import { defaultSectionColorName, type ColorName } from '@canvas/constants';

export const defaultColor = 'none';

export type ColorMap = Record<
  'stickyColor' | 'shapeColor' | 'pathColor' | 'textColor' | 'sectionColor',
  ColorName
>;

export const currentUserColorState: ColorMap = proxy({
  stickyColor: defaultColor,
  shapeColor: defaultColor,
  pathColor: 'n600',
  textColor: 'textDefaultColor',
  sectionColor: defaultSectionColorName,
});
